import React from 'react';
import Components from '../components.js';
import { CriteoLandingTag } from '../Criteo';

const LandingPage = (props) => (
  <div>
    <CriteoLandingTag enabled="true" />
    {props.blok.body &&
      props.blok.body.map((blok) =>
        React.createElement(Components(blok.component), { key: blok._uid, blok: blok })
      )}
  </div>
);

export default LandingPage;
